export const unixToSlot = (unix, network = 0) => Math.trunc(unix) - (network ? 1591566291 : window.__APP_CONFIG.slotOffset);
export const slotToUnix = (slot, network = 0) => Math.trunc(slot + (network ? 1591566291 : window.__APP_CONFIG.slotOffset));
export const getDateFromSlot = (slot, network = 0) => new Date(slotToUnix(Number(slot), network) * 1000);
//# sourceMappingURL=slots.js.map